import React from 'react';
import PropTypes from 'prop-types';
import WizardNavigationContent
  from 'Components/ComponentLibrary/Organisms/Navigation/Container/Content/Navigations/WizardNavigation/WizardNavigationContent';
import { useNewNavbarContext } from 'Components/UI/Navigation/NewNavbar/NewNavbarContext';

const WizardNavigationContentWithContext = ({
  resource,
}) => {
  const { isOpen } = useNewNavbarContext();

  return <WizardNavigationContent isOpen={isOpen} resource={resource} />;
};

WizardNavigationContentWithContext.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default WizardNavigationContentWithContext;
